import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import { logoRedM, logoBlueM, logoPinkM, logoGreenM, logoYellowM, logoDarkBlueM, burnishedSilver } from 'web-ui-kit/colors';
import { Flex } from 'web-ui-kit/containers';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

var slideDownOne = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  10% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  20% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  30% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  40% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  50% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  60% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  70% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  opacity: 0;\n"])));
var slideDownTwo = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  10% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  20% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  30% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  40% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  50% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  60% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  70% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  opacity: 0;\n"])));
var slideDownThree = keyframes(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  10% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  20% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  30% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  40% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  50% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  60% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  70% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  opacity: 0;\n"])));
var slideDownFour = keyframes(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  10% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  20% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  30% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  40% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  50% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  60% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n  70% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  opacity: 0;\n"])));
var slideDownFive = keyframes(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  10% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  20% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  30% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  40% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  50% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  60% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  70% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  opacity: 0;\n"])));
var slideDownSix = keyframes(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  10% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  20% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  30% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  40% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  50% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  60% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  70% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  opacity: 0;\n"])));
var slideUp = keyframes(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(0);\n    opacity: 0;\n  }\n\n  70% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n\n  100% {\n    transform: translateY(-32px);\n    opacity: 1;\n  }\n"])));
var rotate = keyframes(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"])));

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;

var darken = function darken(n) {
  return "rgba(0, 0, 0, ".concat(n, ")");
};

var delay = 0;
var length = 2000;
var largeSvg = [{
  clipPath: '0 0, 62px 63.7px, 62px 95px, 0 31.3px, 0 31.3px, 0 0, 0 0',
  backgroundColor: logoRedM,
  animation: css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["", " ", "ms ", "ms infinite"])), slideDownTwo, length, delay)
}, {
  clipPath: '62px 0, 0 63.7px, 0 95px, 62px 31.3px, 62px 31.3px, 62px 0, 62px 0',
  backgroundColor: logoBlueM,
  animation: css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["", " ", "ms ", "ms infinite"])), slideDownOne, length, delay)
}];
var smallSvg = [{
  clipPath: '31px 0px, 31px 31.4px, 0px 63px, 0px 31.5px, 31px 0px',
  backgroundColor: logoPinkM,
  animation: css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["", " ", "ms ", "ms infinite"])), slideDownThree, length, delay)
}, {
  clipPath: '31px 31.6px, 31px 63px, 0 31.4px, 0 0, 31px 31.6px',
  backgroundColor: logoGreenM,
  animation: css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["", " ", "ms ", "ms infinite"])), slideDownFour, length, delay)
}, {
  clipPath: '0px 31.6px, 0px 63px, 31px 31.4px, 31px 0px, 0px 31.6px',
  backgroundColor: logoYellowM,
  animation: css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["", " ", "ms ", "ms infinite"])), slideDownFive, length, delay)
}, {
  clipPath: '0 0, 0 31.4px, 31px 63px, 31px 31.5px, 0 0',
  backgroundColor: logoDarkBlueM,
  animation: css(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["", " ", "ms ", "ms infinite"])), slideDownSix, length, delay)
}];
var LargeOverlay = styled.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  background: 0 0 0 60vmax ", ", 0 0 32px ", ";\n  overflow: hidden;\n  width: 62px;\n  height: 95px;\n  clip-path: polygon(", ");\n"])), darken(1 / 2), darken(1 / 4), function (p) {
  return p.clipPath;
});
var LargeSvg = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 62px;\n  height: 95px;\n  overflow-y: hidden;\n  opacity: 1;\n  transform: translateY(-32px);\n  clip-path: polygon(", ");\n  background-color: ", ";\n  animation: ", ";\n"])), function (p) {
  return p.clipPath;
}, function (p) {
  return p.backgroundColor;
}, function (p) {
  return p.animation;
});
var SmallSvg = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 31px;\n  height: 63px;\n  overflow-y: hidden;\n  clip-path: polygon(", ");\n  background-color: ", ";\n  animation: ", ";\n  opacity: 1;\n  transform: translateY(-32px);\n"])), function (p) {
  return p.clipPath;
}, function (p) {
  return p.backgroundColor;
}, function (p) {
  return p.animation;
});
var SmallOverlay = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 31px;\n  height: 63px;\n  overflow-y: hidden;\n  background: 0 0 0 60vmax ", ", 0 0 32px ", ";\n  clip-path: polygon(", ");\n"])), darken(1 / 2), darken(1 / 4), function (p) {
  return p.clipPath;
});
var Container = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  z-index: 9999999;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  position: ", ";\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n"])), function (props) {
  return props.position ? props.position : 'fixed';
});
var SmallWrap = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 31px;\n  height: 65px;\n  display: flex;\n"])));
var LargeWrap = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 62px;\n  height: 95px;\n  bottom: 32px;\n"])));
var SpinnerContainer = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  width: ", "px;\n  height: ", "px;\n  border-top: ", "px solid ", ";\n  border-right: ", "px solid ", ";\n  border-bottom: ", "px solid transparent;\n  border-left: ", "px solid transparent;\n  animation: ", " 1s infinite linear;\n  overflow: visible;\n"])), function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.borderWidth;
}, function (props) {
  return props.color;
}, function (props) {
  return props.borderWidth;
}, function (props) {
  return props.color;
}, function (props) {
  return props.borderWidth;
}, function (props) {
  return props.borderWidth;
}, rotate);
SpinnerContainer.displayName = 'SpinnerContainer';
var SpinnerRoundedEdge = styled.span(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display:block;\n  position: absolute;\n  border-radius: 50%;\n  width: ", "px;\n  height: ", "px;\n  background: ", ";\n"])), function (props) {
  return props.borderWidth;
}, function (props) {
  return props.borderWidth;
}, function (props) {
  return props.color;
});
var SpinnerRoundedEdgeRight = styled(SpinnerRoundedEdge)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  bottom: ", "px;\n  right: ", "px;\n"])), function (props) {
  return props.positionOffset;
}, function (props) {
  return props.positionOffset;
});
SpinnerRoundedEdgeRight.displayName = 'SpinnerRoundedEdgeRight';
var SpinnerRoundedEdgeLeft = styled(SpinnerRoundedEdge)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  top: ", "px;\n  left: ", "px;\n"])), function (props) {
  return props.positionOffset;
}, function (props) {
  return props.positionOffset;
});
SpinnerRoundedEdgeLeft.displayName = 'SpinnerRoundedEdgeLeft';

function RoundedSpinner() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? burnishedSilver : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 40 : _ref$size;

  var positionOffset = size * 0.05;
  var borderWidth = size * 0.075;
  return (
    /*#__PURE__*/
    React.createElement(SpinnerContainer, {
      className: className,
      "data-testid": "rounded-spinner",
      size: size,
      borderWidth: borderWidth,
      color: color
    },
    /*#__PURE__*/
    React.createElement(SpinnerRoundedEdgeLeft, {
      borderWidth: borderWidth,
      positionOffset: positionOffset,
      color: color
    }),
    /*#__PURE__*/
    React.createElement(SpinnerRoundedEdgeRight, {
      borderWidth: borderWidth,
      positionOffset: positionOffset,
      color: color
    }))
  );
}

function Loader(_ref2) {
  var position = _ref2.position,
      _ref2$animated = _ref2.animated,
      animated = _ref2$animated === void 0 ? true : _ref2$animated,
      _ref2$dataTestId = _ref2.dataTestId,
      dataTestId = _ref2$dataTestId === void 0 ? 'modsy-heart-loader' : _ref2$dataTestId;
  return (
    /*#__PURE__*/
    React.createElement(Container, {
      position: position,
      "data-testid": dataTestId
    },
    /*#__PURE__*/
    React.createElement(Flex, null, smallSvg.map(function (svg, index) {
      return (
        /*#__PURE__*/
        React.createElement(SmallWrap, {
          key: index
        },
        /*#__PURE__*/
        React.createElement(SmallSvg, _extends({}, svg, {
          animation: animated ? svg.animation : ''
        })),
        /*#__PURE__*/
        React.createElement(SmallOverlay, _extends({}, svg, {
          animation: animated ? svg.animation : ''
        })))
      );
    })),
    /*#__PURE__*/
    React.createElement(Flex, null, largeSvg.map(function (svg, index) {
      return (
        /*#__PURE__*/
        React.createElement(LargeWrap, {
          key: index
        },
        /*#__PURE__*/
        React.createElement(LargeSvg, _extends({}, svg, {
          animation: animated ? svg.animation : ''
        })),
        /*#__PURE__*/
        React.createElement(LargeOverlay, _extends({}, svg, {
          animation: animated ? svg.animation : ''
        })))
      );
    })))
  );
}
/**
 * Intended for BW compatibility with modsy-ui-kit.
 * These extra props come from react-loadable.
 */


function LoadingIndicator(_ref3) {
  var error = _ref3.error,
      isLoading = _ref3.isLoading,
      pastDelay = _ref3.pastDelay,
      position = _ref3.position,
      timedOut = _ref3.timedOut;

  if (error) {
    return (
      /*#__PURE__*/
      React.createElement("div", null, "Error! Component failed to load")
    );
  }

  if (!isLoading && !timedOut && !pastDelay) {
    return null; // no reason to render loader yet
  }

  if (timedOut) {
    return (
      /*#__PURE__*/
      React.createElement("div", null, "Loader timed out!")
    );
  } // Delay time has passed, go ahead and render loader.


  return (
    /*#__PURE__*/
    React.createElement(Loader, {
      position: position
    })
  );
}

export { Loader, LoadingIndicator, RoundedSpinner, SpinnerContainer, SpinnerRoundedEdgeLeft, SpinnerRoundedEdgeRight, darken };